import { useTranslation } from 'react-i18next';

import { ProgressCell } from '@work4all/components/lib/dataDisplay/basic-table/utils/cells/ProgressCell';

import { SalesOpportunities } from '@work4all/models/lib/Classes/SalesOpportunities.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';
import { SalesOpportunityStatus } from '@work4all/models/lib/Enums/SalesOpportunityStatus.enum';

import { OrganisationArea } from '../organisation-area';

import { SalesOpportunityStatusCell } from './cell-renderer/SalesOpportunityStatusCell';
import { TendencyCell } from './cell-renderer/TendencyCell';
import { EntityTableV8, IEntityTableV8 } from './entity-table/EntityTableV8';
import { useEntityDataTableV8 } from './entity-table/use-entity-data-table-v8';
import schema from './schemata/salesOpportunities-table-schema.json';

const defaultSort = [
  { field: 'dateCreated', direction: SortDirection.DESCENDING },
];

export function SalesOpportunitiesTable(props: IEntityTableV8) {
  const dataTable = useEntityDataTableV8<
    SalesOpportunities,
    Record<string, never>
  >({
    ...props,
    schema: schema as never,
    defaultSort,
    cells: {
      TendencyCell,
      ProgressCell,
      SalesOpportunityStatusCell,
    },
    enableFooter: true,
    rowModifiers: (value) => {
      return {
        isFaded: [
          SalesOpportunityStatus.CONVERTED_TO_ORDER,
          SalesOpportunityStatus.CONVERTED_TO_INVOICE,
          SalesOpportunityStatus.CONVERTED_TO_DELIVERY_NOTE,
          SalesOpportunityStatus.CONVERTED_TO_OFFER,
          SalesOpportunityStatus.LOST,
          SalesOpportunityStatus.HIDE,
        ].includes(value.status),
      };
    },
  });

  const { t } = useTranslation();

  return (
    <EntityTableV8
      {...props}
      {...dataTable}
      footerCellProps={{ minimumFractionDigits: 0, maximumFractionDigits: 0 }}
      areas={{
        left: {
          title: t('COMMON.ORGANISATION'),
          content: (
            <OrganisationArea
              entity={Entities.salesOpportunities}
              table={dataTable.table}
            />
          ),
          resizable: true,
          collapsible: true,
          custom: true,
        },
      }}
      displayFooter
    />
  );
}
